export default __webpack_public_path__ + "static/media/halibut.c47d0da2.jpg";